<div class="modal modal_pb_40 modal_size_744 modal__opened">
  <div class="modal__backlink with-icon" (click)="back()" *ngIf="!newGroup && !rulesSaved">{{ 'edit-group-modal.back' | translate }}</div>
  <div class="modal__close icon icon-close" (click)="close()"></div>

  <ng-container [ngTemplateOutlet]="groupEdit" *ngIf="!showRules && !rulesSaved"></ng-container>

  <app-rules-block *ngIf="showRules && !rulesSaved" [rules]="rules" (saveRules)="saveRules($event)" (deleteRules)="deleteRules()" [requestInProgress]="requestInProgress"></app-rules-block>

  <ng-container [ngTemplateOutlet]="ruleSaved" *ngIf="rulesSaved"></ng-container>
</div>

<ng-template #groupEdit>
  <div class="modal__container">
    <div class="modal__title h2">{{ (newGroup ? 'edit-group-modal.add-group' : 'edit-group-modal.edit-group') | translate }}</div>
    <div class="info-hint">{{ 'edit-group-modal.groups-hint' | translate }}</div>
    <div class="modal__content modal__content-w375px">
      <div class="modal__form-field">
        <div class="input input_width_auto">
          <label class="input__label">{{ 'edit-group-modal.name' | translate }}</label>
          <div class="input__container" [class.input_type_error]="groupError">
            <input type="text" [placeholder]="'edit-group-modal.name-placeholder' | translate" class="input__input" [(ngModel)]="title" (ngModelChange)="groupFieldChanged()"
                   maxlength="50" [patterns]="titlePattern" [specialCharacters]="[]" mask="T{50}" (input)="groupChange()">
          </div>
          <div class="select__error" *ngIf="groupError">{{ groupError | translate }}</div>
        </div>
      </div>
      <div class="modal__form-field modal__content-w375px">
        <app-contacts-select [contacts]="contacts" (selectionChanged)="contactsSelectionChanged()" [hasError]="contactsError?.length > 0"></app-contacts-select>
        <div class="select__error" *ngIf="contactsError">{{ contactsError | translate }}</div>
      </div>
    </div>
  </div>
  <div class="modal__buttons modal__buttons-mt72">
    <div class="button" [class.button_status_disabled]="!nextActive" [class.button_type_load]="requestInProgress" (click)="saveGroup()">{{ 'edit-group-modal.next' | translate }}
    </div>
  </div>
</ng-template>

<ng-template #ruleSaved>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2">{{ 'edit-group-modal.rules-saved' | translate }}</div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="close()">{{ 'edit-group-modal.ok-btn' | translate }}</div>
  </div>
</ng-template>
